/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Spaces_Embedding_Priority_NormalInputs */



/**
* | output |
* | --- |
* | "Normal" |
*
* @param {Spaces_Embedding_Priority_NormalInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const spaces_embedding_priority_normal = /** @type {((inputs?: Spaces_Embedding_Priority_NormalInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Spaces_Embedding_Priority_NormalInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return /** @type {LocalizedString} */ ("Normal")
	return /** @type {LocalizedString} */ ("Normal")
});